import React from "react";
import NewEpos from "../../Epos/view/NewEpos";
import NewEposRhp from "./NewEposRhp";
import { isRhpEposTenant } from "../../Epos/utils/cartCalculations";

const NewEposEntry = () => {
  if (isRhpEposTenant()) {
    return <NewEposRhp />;
  }
  return <NewEpos />;
};

export default NewEposEntry;
